import * as React from "react";

export const useKeyPress = function (targetKey: KeyboardEvent["key"]) {
  const [keyPressed, setKeyPressed] = React.useState(false);

  const downHandler = React.useCallback(
    (event: KeyboardEvent) => {
      const { key } = event;
      if (key === targetKey) {
        event.preventDefault();
        setKeyPressed(true);
      }
    },
    [targetKey, setKeyPressed]
  );

  const upHandler = React.useCallback(
    (event: KeyboardEvent) => {
      const { key } = event;
      if (key === targetKey) {
        event.preventDefault();
        setKeyPressed(false);
      }
    },
    [targetKey, setKeyPressed]
  );

  React.useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  });

  return keyPressed;
};
